export default __webpack_public_path__ + "static/media/air-pod.113f27c4.jpg";